import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppGtmVehicle, IValidationError } from '@impact/data';

import { TrackingService } from '../utils/tracking/tracking.service';

@Injectable({ providedIn: 'root' })
export class FormService {
    constructor(private readonly trackingService: TrackingService) {}

    static markControlsAsTouched(form: UntypedFormGroup): void {
        for (const control in form.controls) {
            if (form.controls[control].pristine) {
                form.controls[control].markAsTouched();
                form.controls[control].updateValueAndValidity();
            }
        }
    }

    static markValidationErrors(validationErrors: IValidationError[], form: UntypedFormGroup) {
        validationErrors.forEach((validationError) => {
            const field = form.get(validationError.property);
            if (field) {
                field.setErrors({ required: validationError.error });
            }
        });
    }

    static errors(controlName: string, form?: UntypedFormGroup) {
        if (form) {
            const control = form.controls[controlName];
            if (control.invalid && (control.dirty || control.touched)) {
                return control.errors;
            }
        }
        return null;
    }

    trackInitialization(formName: string): void {
        this.trackingService.trackFormEvent('initialization', formName);
    }

    trackStep(formName: string, stepNumber: number): void {
        this.trackingService.trackFormEvent(`step-${stepNumber}`, formName);
    }

    trackCompletion(formName: string, hasConsent = false, vehicle?: AppGtmVehicle, customData?: Record<string, unknown>): void {
        this.trackingService.trackFormEvent('completion', formName, hasConsent, vehicle, customData);
    }
}
